import { Row } from 'antd';
import type { Gutter } from 'antd/es/grid/row';

export const AntRow = Row;
export type AntGutter = Gutter;
